import { render, staticRenderFns } from "./NewDFileUploadEditor.vue?vue&type=template&id=4506f4ee&"
import script from "./NewDFileUploadEditor.vue?vue&type=script&lang=js&"
export * from "./NewDFileUploadEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewDFileUploadEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports